<template>
  <div :class="['search', $isInWxMP ? 'top-0' : '']" >
    <div class="content" v-if="searchParams.readOnly" @click="searchHref">
      <SvgIcon icon-class="search" />
      {{searchParams.placeholder || '请输入姓名、完整手机号'}}
    </div>
    <template v-else>
      <div class="content">
        <SvgIcon icon-class="search" />
        <form action="" @submit.prevent="">
          <input
            ref="input"
            type="search"
            :placeholder="searchParams.placeholder || '请输入姓名、完整手机号'"
            v-model="query"
            @focus="focusFn(true)"
            @keydown.enter="searchFn"
          />
        </form>
        <img src="../assets/close01.png" alt="" v-if="query" @click="clearFn">
      </div>

      <button v-if="searchParams.type === 'search'" @click="searchFn" class="search-btn"  >搜索</button>
      <button v-else  @click="cancelFn">取消</button>
    </template>
  </div>
</template>

<script>
import { sendLog } from '@/api/addLog';

export default {
  name: 'Search',
  emits: ['focusFn'],
  props: {
    searchParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      query: '',
    };
  },
  watch: {
    'searchParams.focus': {
      handler() {
        if (this.searchParams.readOnly) return;

        if (this.searchParams.focus) {
          this.$nextTick(() => {
            this.$refs.input.focus();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.input.blur();
          });
        }
      },
      deep: true,
      immediate: true,
    },
    'searchParams.query': {
      handler() {
        if (this.searchParams.readOnly) return;

        this.query = this.searchParams.query;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 跳转搜索页面
    searchHref() {
      this.$router.push({
        path: '/doctor-search',
      });

      sendLog('EXPERT_LIST_ClickSearch');
    },
    // 聚焦
    focusFn(val) {
      this.$emit('focusFn', val);
    },
    // 清空
    clearFn() {
      this.query = '';
      this.$refs.input.focus();
    },
    // 取消
    cancelFn() {
      this.$router.go(-1);
    },
    // 搜索
    searchFn() {
      this.$refs.input.blur();
      this.$emit('searchFn', this.query);
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  height: 52px;
  background-color: #fff;
  padding: 8px 15px;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  right: 0;
  top: 44px;
  z-index: 10;

  @include flex(center, space-between);

  &.top-0 {
    top: 0;
  }

  .content {
    width: 100%;
    background-color: $background-color-2;
    border-radius: 18px;
    padding: 8px 15px;
    position: relative;

    @include flex();
    @include font(14px, 20px, $regular-text-color);

    form {
      width: 100%;
    }
  }

  .svg-icon {
    flex-shrink: 0;
    margin-right: 8px;
    font-size: 14px;
  }

  input {
    width: 100%;
    padding-right: 25px;
    color: $primary-text-color;
  }

  input::-webkit-search-decoration,
  input::-webkit-search-cancel-button {
    display: none;
  }

  img {
    width: 15px;
    padding: 10px;
    position: absolute;
    right: 5px;
    top: 0;
  }

  button {
    flex-shrink: 0;
    padding: 8px 10px;
    margin-left: 5px;
    margin-right: -10px;

    @include font(14px, 20px, $secondary-text-color);

    &.search-btn {
      color: $secondary-text-color;
    }
  }
}
</style>
